<ng-template #tiktokAppInfoModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">TikTok App Information</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>App Name</th>
            <th>Region</th>
            <th>Used Count</th>
            <th>Register Link</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let app of appInfos">
            <td>{{app.appName}}</td>
            <td>{{app.region}}</td>
            <td>{{app.used}}</td>
            <td class="text-center can-copy">
              <span class="btn btn-link" ngxClipboard [cbContent]="app.registerLink"
                    (cbOnSuccess)="onCoppied()">Register</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>

<button class="btn btn-primary" (click)="openModal()" style="margin-right: 10px">TikTok App Info</button> 
